<script>
import axios from "axios";
import FormDocumento from "../../formulario/FormDocumento.vue";
import FormDocumentoEditar from "../../formulario/FormDocumentoEditar.vue";

import SearchDINModal from "./search-docs/SearchDINModal.vue";
import SearchDUSModal from "./search-docs/SearchDUSModal.vue";
import SearchAforoModal from "./search-docs/SearchAforoModal.vue";
import SearchTransactionBaucherModal from "./search-docs/SearchTransactionBaucherModal.vue";
import DownloadPDFModal from "./search-docs/DownloadPDFModal.vue";

import { basename } from "../../../helpers/file_path";

export default {
  components: {
    FormDocumento,
    FormDocumentoEditar,
    SearchDINModal,
    SearchDUSModal,
    SearchAforoModal,
    SearchTransactionBaucherModal,
    DownloadPDFModal,
  },
  props: {
    agregarDocumento: Boolean,
    documentosTabla: Array,
    documentos: Object,
    validate_permission: { type: Boolean, required: false, default: false },
    postDocumento: Function,
    updateDocumento: Function,
    eliminarDocumento: Function,
    showDeleteDocumentos: Boolean,
    eliminarDocumentos: Function,
    actualizarDocumentos: Function,
    confirmarDeleteDocumentos: Function,
    cerrarModal: Function,
    metodoThen: Function,
    metodoCatch: Function,
    exportDocuments: {
      type: Boolean,
      default: false,
    },
    general: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["actualizar-documentos"],
  computed: {
    disableDINButton() {
      return this.despacho?.is_din_scrapped ?? true;
    },
    disableTGRButton() {
      return this.despacho?.is_tgr_scrapped ?? true;
    }
  },
  data() {
    return {
      fields: [
        { key: "tipo", label: "Tipo" },
        { key: "fecha_recepcion", label: "Fecha" },
        { key: "usuario.name", label: "Usuario" },
        { key: "documentos", label: "Documento" },
        { key: "estado", label: "Estado Validación" },
        { key: "actions", label: "Acciones", class: "text-center" },
      ],
      despacho: undefined,
      editar: false,

      documentoEditar: null,

      files_old: [],

      idDespacho: "",

      showSearchDINModal: false,
      showSearchDUSModal: false,
      showSearchAforoModal: false,
      showSearchTransactionBaucherModal: false,
      showDownloadPDFModal: false,

      downloadZIPIsPending: undefined,
    };
  },
  methods: {
    editarDocumento(documento) {
      this.documentoEditar = documento;

      this.files_old = [];
      this.documentoEditar.archivos.forEach((el) => {
        this.files_old.push({ id: el.id, name: el.ruta });
      });
      this.editar = true;
    },
    cancelar() {
      this.editar = false;
    },

    async refetchDocsDispatch() {
      await this.getDispatch();
      await this.actualizarDocumentos();
    },

    async viewDocument(id) {
      //window.open(process.env.VUE_APP_API_URL +`/api/admin/archivo/${id}/descargar`);
      this.$router.push({
        name: "Documento",
        params: { despachoId: this.idDespacho, documentoId: id },
      });
    },

    async getDispatch() {
      try {
        const { data } = await axios.get(
          `api/admin/despachos/${this.idDespacho}`
        );

        if (data?.data) {
          this.despacho = data.data;
          this.getDocumentoPorDespacho(this.despacho.id);
        }
      } catch (e) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al cargar el despacho.",
        });
      }
    },
    async getDocumentoPorDespacho(despacho) {
      try {
        const { data } = await axios.get(
          `api/admin/documentos/despacho/${despacho}`
        );

        if (data?.data) this.documentosDespacho = data.data.documentos;
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "Error",
          text: "Hubo un error al cargar los documentos.",
        });
      }
    },

    async validar(id, estado) {
      try {
        await axios.post(`api/admin/documentos/${id}/validar`, {
          estado: estado,
        });
      } catch (e) {
        console.error(e);
      }

      this.actualizarDocumentos();
      this.getDispatch();
    },

    async downloadDocumentZip() {
      const config = {
        responseType: "blob",
      };

      try {
        this.downloadZIPIsPending = true;
        const { data } = await axios.get(
          `api/admin/documentos/${this.idDespacho}/descargar-zip`,
          config
        );

        if (data) {
          const href = URL.createObjectURL(data);

          const link = document.createElement("a");
          link.href = href;
          link.setAttribute(
            "download",
            this.idDespacho +
              "-" +
              this.moment(new Date()).format("DD-MM-YYYY") +
              ".zip"
          );
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (e) {
        console.error(e);

        const parsedErr = await e?.response?.data?.text();
        const json = JSON.parse(parsedErr);

        if (json?.message) {
          this.$swal({
            icon: "error",
            title: "Error",
            text: json.message,
          });
        }
      }
      this.downloadZIPIsPending = false;
    },

    async downloadFile(archivos) {
      const config = {
        responseType: "blob",
      };
      const notFoundFiles = [];

      for (const file of archivos) {
        if (file) {
          try {
            const { data } = await axios.get(
              `api/archivo/${file.id}/descargar`,
              config
            );

            if (data) {
              const href = URL.createObjectURL(data);

              const link = document.createElement("a");
              link.href = href;
              link.setAttribute("download", basename(file.ruta));
              document.body.appendChild(link);
              link.click();

              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            }
          } catch (error) {
            notFoundFiles.push(file.ruta);
            console.log(notFoundFiles);
          }
        }
      }

      if (notFoundFiles.length > 0) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: `Los siguientes archivos no están disponbiles:\n\n ${notFoundFiles.join(
            "\n"
          )}`,
        });
      }
    },
  },
  mounted() {
    this.idDespacho = this.$route.params.despachoId;
    this.id = this.$route.params.despachoId;
    this.getDispatch();
  },
};
</script>

<template>
  <div class="flex flex-col gap-8 px-[2%]">
    <div class="flex flex-col gap-4">
      <div
        class="flex flex-col xl:flex-row w-full justify-between gap-4 xl:gap-2"
      >
        <div class="flex flex-row gap-4" v-if="general">
          <button
            class="btn-principal"
            type="button"
            :disabled="disableDINButton"
            @click="() => (showSearchDINModal = true)"
          >
            Buscar DIN
          </button>
          <button
            class="btn-principal"
            type="button"
            @click="() => (showSearchDUSModal = true)"
          >
            Buscar DUS
          </button>

          <button
            class="btn-principal"
            type="button"
            @click="() => (showSearchAforoModal = true)"
          >
            Buscar consulta de aforo
          </button>

          <button
            class="btn-principal"
            type="button"
            :disabled="disableTGRButton"
            @click="() => (showSearchTransactionBaucherModal = true)"
          >
            Buscar comprobante de pago
          </button>
        </div>

        <div
          class="flex flex-row flex-wrap items-center gap-4 w-full xl:justify-end"
        >
          <b-dropdown
            id="download-dropdown"
            text="Exportar"
            v-if="exportDocuments"
            class=""
          >
            <b-dropdown-item :disabled="documentosTabla?.length == 0">
              <div
                @click="() => (showDownloadPDFModal = true)"
                class="flex flex-row items-center gap-2"
              >
                <fas :icon="['fas', 'file-pdf']" />
                Compilación en PDF
              </div>
            </b-dropdown-item>
            <b-dropdown-item :disabled="documentosTabla?.length == 0">
              <div
                @click="downloadDocumentZip()"
                class="flex flex-row items-center gap-2"
              >
                <fas :icon="['fas', 'folder']" />
                Carpeta ZIP
              </div>
            </b-dropdown-item>
          </b-dropdown>

          <button
            id="deleteAll"
            @click="eliminarDocumentos()"
            class="btn-principal ml-auto"
            :disabled="documentosTabla?.length == 0"
          >
            <fas :icon="['fas', 'trash']" />
            Eliminar Documentos
          </button>
        </div>
      </div>

      <b-modal
        v-model="showDeleteDocumentos"
        id="modal-eliminar"
        centered
        @hidden="cerrarModal()"
      >
        <template #modal-title> Eliminar documentos </template>
        <div class="d-block text-center">
          <h3>¿Desea eliminar todos los documentos?</h3>
        </div>
        <template #modal-footer>
          <button
            type="button"
            class="btn-secundario btn-large"
            @click="confirmarDeleteDocumentos()"
          >
            Eliminar
          </button>
          <button
            type="button"
            class="btn-principal btn-large"
            @click="cerrarModal()"
          >
            Cancelar
          </button>
        </template>
      </b-modal>

      <b-modal
        v-model="downloadZIPIsPending"
        id="modal-export-documents"
        centered
        hide-header
        hide-footer
      >
        <div class="h-48 flex flex-row items-center justify-center">
          <b-spinner class="text-primary" style="width: 3em; height: 3em" />
        </div>
      </b-modal>

      <form-documento
        v-if="agregarDocumento && !editar"
        :postDocumento="postDocumento"
        :documentos="documentos"
        :cancelar="cancelar"
        :tipo="despacho?.tipo_despacho"
        :despacho="despacho"
      >
      </form-documento>

      <form-documento-editar
        v-if="agregarDocumento && editar && documentoEditar"
        :postDocumento="updateDocumento"
        :documentos="documentos"
        :documentoEditar="documentoEditar"
        :cancelar="cancelar"
        :files_old="files_old"
        :despacho="despacho"
      >
        <template slot="cancelar">
          <button
            class="btn-secundario btn-small"
            @click="cancelar()"
            type="button"
          >
            Cancelar
          </button>
        </template>
      </form-documento-editar>
    </div>

    <div>
      <b-table
        striped
        hover
        :items="documentosTabla"
        :fields="fields"
        show-empty
        responsive
      >
        <template #empty>
          <h1 class="text-center">No hay documentos disponibles</h1>
        </template>

        <template #cell(tipo)="row">
          <div v-if="row.item.tipo_documentos_id != 20">
            {{ row.item.tipo.nombre }}
          </div>
          <p v-else>{{ row.item.base.nombre_documento }}</p>
        </template>

        <template #cell(documentos)="row">
          <div
            class="flex flex-row flex-wrap gap-2 items-center justify-center"
          >
            <button
              class="w-[20px] aspect-square hover:scale-110 transition-all"
              v-b-tooltip.hover
              :title="documento.ruta"
              v-for="(documento, index) in row.item.archivos"
              :key="index"
              @click="viewDocument(row.item.id)"
            >
              <inline-svg
                v-if="documento.ruta.split('.').at(-1) == 'pdf'"
                src="../../assets/images/archivo-pdf.svg"
              />
              <inline-svg
                v-if="
                  documento.ruta.split('.').at(-1) == 'png' ||
                  documento.ruta.split('.').at(-1) == 'jpg' ||
                  documento.ruta.split('.').at(-1) == 'jpeg'
                "
                src="../../assets/images/archivo-png.svg"
              />
              <inline-svg
                v-if="
                  documento.ruta.split('.').at(-1) == 'xlsx' ||
                  documento.ruta.split('.').at(-1) == 'xls'
                "
                src="../../assets/images/732220.svg"
              />
            </button>
          </div>
        </template>

        <template #cell(fecha_recepcion)="row">
          <div>{{ moment(row.item.fecha_recepcion).format("DD-MM-YYYY") }}</div>
        </template>

        <template #cell(actions)="row">
          <div class="flex flex-col gap-4">
            <div class="flex flex-row gap-2 justify-center">
              <button
                @click="viewDocument(row.item.id)"
                class="btn-extra-primario btn-small mr-1"
              >
                <fas :icon="['fas', 'eye']" />
                Ver
              </button>
              <button
                v-if="agregarDocumento"
                @click="editarDocumento(row.item)"
                class="btn-extra-secundario btn-small mr-1"
              >
                <fas :icon="['fas', 'edit']" />
                Editar
              </button>
              <button
                v-if="agregarDocumento"
                @click="eliminarDocumento(row.item.id, row.item.tipo.nombre)"
                class="btn-extra-primario"
              >
                <fas :icon="['fas', 'trash']" />
                Eliminar
              </button>
              <button
                @click="downloadFile(row.item.archivos)"
                class="btn-extra-primario"
              >
                <fas :icon="['fas', 'download']" />
                Descargar
              </button>
            </div>
            <div
              v-if="validate_permission"
              class="flex flex-row items-center gap-2 justify-center"
            >
              <button
                @click="validar(row.item.id, 'Aceptado')"
                class="btn-extra-secundario"
              >
                <fas :icon="['fas', 'check']" />
                Aceptado
              </button>
              <button
                @click="validar(row.item.id, 'Rechazado')"
                class="btn-extra-primario"
              >
                <fas :icon="['fas', 'ban']" />
                Rechazado
              </button>
            </div>
          </div>
        </template>
      </b-table>
    </div>

    <SearchDINModal
      :open="showSearchDINModal"
      @close-modal="() => (showSearchDINModal = false)"
      :dispatch="despacho"
      @refetch="() => refetchDocsDispatch()"
    />
    <SearchDUSModal
      :open="showSearchDUSModal"
      @close-modal="() => (showSearchDUSModal = false)"
      :dispatch="despacho"
      @refetch="() => refetchDocsDispatch()"
    />

    <SearchAforoModal
      :open="showSearchAforoModal"
      @close-modal="() => (showSearchAforoModal = false)"
      @refetch="() => refetchDocsDispatch()"
      :dispatch="despacho"
    />

    <SearchTransactionBaucherModal
      :open="showSearchTransactionBaucherModal"
      @close-modal="() => (showSearchTransactionBaucherModal = false)"
      @refetch="() => refetchDocsDispatch()"
      :dispatch="despacho"
    />
    <DownloadPDFModal
      :open="showDownloadPDFModal"
      @close-modal="() => (showDownloadPDFModal = false)"
      :dispatch="despacho"
    />
  </div>
</template>
